import React from 'react';
import { DashboardLayout } from "../components/Dashboard";
import { DocumentFilter } from "../components/DocumentFilters";
import { downloadFileWithdrawlApi } from '../api/services-third-parties';
import { useSelector } from 'react-redux';
import { formatDate_hours } from "../core/function/function-generic";

export const Main = () => {
    document.body.style.background = "#FFF";
    const state = useSelector((state: any) => state.business);

    const handleDownload = async (params: any) => {
        try {
            const today = new Date();
            params['business'] = state.id;
            const response = await downloadFileWithdrawlApi(params);
            if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${params['typeOperation']}_${formatDate_hours(today.toISOString())}.${params.fileType}`);
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            // Handle error
        }
    };

    return (
        <DashboardLayout pageTitle="Files by Lot">
            <div className="p-8">
                <DocumentFilter handleDownload={handleDownload} />
            </div>
        </DashboardLayout>
    );
};